module.exports = __webpack_public_path__ + "static/img/post_3.eabe021.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/posts/post_3.png
// module id = mtvs
// module chunks = 0